import { type CrochetDocument, type CrochetDocumentV1, fromCrochetDocumentV1, toCrochetDocument } from '@kinnet-studio/pattern';

import { explodeLegacyArrays } from './explode';

// SP-125, SP-130. The stored-document end of the converter: a crochet document
// v1 may hold stitch arrays, and stitches and links that name them; a v2
// document never does. `parseStoredDiagram` calls this on every v1 document it
// reads, which is how every stored-JSON reader (the IndexedDB stores, the
// remote store, `.stitchpress` import, shared links, the viewer, embeds) ends
// up with a v2 document. Yjs documents are converted separately.

/** v1 document `pattern` as a v2 document: every stitch array turned into
 *  stitches and every reference to an array rewritten, with the editor's
 *  turning chains to match. A v1 document with no array and nothing that
 *  names one comes out with the same content (the converter is copy-on-write);
 *  only its version changes. Stitch groups and annotations aren't the
 *  converter's business and pass through untouched. The input is not changed. */
export function convertLegacyCrochetDocument(
    pattern: CrochetDocumentV1,
    turningChains: readonly string[],
): { pattern: CrochetDocument; turningChains: string[] } {
    const snap = fromCrochetDocumentV1(pattern);
    const converted = explodeLegacyArrays({
        stitches: snap.stitches,
        guides: snap.guides,
        arrayTbcs: snap.arrayTbcs,
        verticalLinks: snap.verticalLinks,
        spaces: snap.spaces ?? new Map(),
        turningChains: new Set(turningChains),
    });
    return {
        pattern: toCrochetDocument({
            stitches: converted.stitches,
            guides: converted.guides,
            verticalLinks: converted.verticalLinks,
            stitchGroups: snap.stitchGroups,
            spaces: converted.spaces,
            annotations: snap.annotations,
        }),
        turningChains: [...converted.turningChains],
    };
}
